import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom"
import Navbar from "../../../components/organisms/Navbar/Navbar"
import "./PublicLayout.css"


const Layout = () => {
    return (
        <div className="landing-page-layout">
            <Navbar />
            <Outlet />
        </div>
    )
}

export default Layout
